import { render } from "./BestSellers.vue?vue&type=template&id=1e6d7fdd"
import script from "./BestSellers.vue?vue&type=script&lang=js"
export * from "./BestSellers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/BestSellers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e6d7fdd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e6d7fdd', __exports__)) {
    api.reload('1e6d7fdd', __exports__)
  }
  
  module.hot.accept("./BestSellers.vue?vue&type=template&id=1e6d7fdd", () => {
    api.rerender('1e6d7fdd', render)
  })

}


export default __exports__